import apiClient from "../helpers/ApiClient";

// --- DASHBOARD & REPORTS ---
export const getPoolDashboardStats = async (poolId = null) => {
  const res = await apiClient.get("/pool/dashboard-stats", {
    params: poolId ? { pool_id: poolId } : {}
  });
  return res.data;
};

export const getPoolReports = async (params = {}) => {
  const res = await apiClient.get("/pool/reports", { params });
  return res.data;
};

// --- POOLS MASTER & OCCUPANCY ---
export const getPools = async () => {
  const res = await apiClient.get("/pool/pools");
  return res.data;
};

export const getPoolById = async (id) => {
  const res = await apiClient.get(`/pool/pools/${id}`);
  return res.data;
};

export const createPool = async (data) => {
  const res = await apiClient.post("/pool/pools", data);
  return res.data;
};

export const updatePool = async (id, data) => {
  const res = await apiClient.put(`/pool/pools/${id}`, data);
  return res.data;
};

export const updatePoolStatus = async (id, status, status_reason = "") => {
  const res = await apiClient.patch(`/pool/pools/${id}/status`, { status, status_reason });
  return res.data;
};

export const getLiveOccupancy = async (id) => {
  const res = await apiClient.get(`/pool/pools/${id}/live-occupancy`);
  return res.data;
};

// --- OCCUPANCY CORRECTIONS ---
export const recordOccupancyCorrection = async (poolId, data) => {
  const res = await apiClient.post(`/pool/pools/${poolId}/occupancy-correction`, data);
  return res.data;
};

export const getOccupancyCorrections = async (poolId = null) => {
  const res = await apiClient.get("/pool/occupancy-corrections", {
    params: poolId ? { pool_id: poolId } : {}
  });
  return res.data;
};

// --- MEMBERSHIPS ---
export const getMembershipPlans = async () => {
  const res = await apiClient.get("/pool/membership-plans");
  return res.data;
};

export const createMembershipPlan = async (data) => {
  const res = await apiClient.post("/pool/membership-plans", data);
  return res.data;
};

export const updateMembershipPlan = async (id, data) => {
  const res = await apiClient.put(`/pool/membership-plans/${id}`, data);
  return res.data;
};

export const getMemberships = async (params = {}) => {
  const res = await apiClient.get("/pool/memberships", { params });
  return res.data;
};

export const getMembershipById = async (id) => {
  const res = await apiClient.get(`/pool/memberships/${id}`);
  return res.data;
};

export const createMembership = async (data) => {
  const res = await apiClient.post("/pool/memberships", data);
  return res.data;
};

export const freezeMembership = async (id, reason) => {
  const res = await apiClient.post(`/pool/memberships/${id}/freeze`, { reason });
  return res.data;
};

export const renewMembership = async (id, data) => {
  const res = await apiClient.post(`/pool/memberships/${id}/renew`, data);
  return res.data;
};

export const validateMemberCheckin = async (membershipNumber, poolId = null) => {
  const res = await apiClient.get("/pool/memberships/validate", {
    params: { membership_number: membershipNumber, pool_id: poolId }
  });
  return res.data;
};

// --- ADMISSIONS & TICKETING ---
export const getAdmissions = async (params = {}) => {
  const res = await apiClient.get("/pool/admissions", { params });
  return res.data;
};

export const getAdmissionByQr = async (token) => {
  const res = await apiClient.get(`/pool/admissions/qr/${token}`);
  return res.data;
};

export const createAdmissionTicket = async (data) => {
  const res = await apiClient.post("/pool/admissions", data);
  return res.data;
};

export const checkinAdmission = async (ticketIdOrToken) => {
  const res = await apiClient.post("/pool/admissions/checkin", { ticket_id_or_token: ticketIdOrToken });
  return res.data;
};

export const checkoutAdmission = async (ticketIdOrToken) => {
  const res = await apiClient.post("/pool/admissions/checkout", { ticket_id_or_token: ticketIdOrToken });
  return res.data;
};

export const cancelAdmission = async (id, reason = "") => {
  const res = await apiClient.post(`/pool/admissions/${id}/cancel`, { reason });
  return res.data;
};

// --- WATER QUALITY ---
export const getWaterQualityLogs = async (params = {}) => {
  const res = await apiClient.get("/pool/water-quality", { params });
  return res.data;
};

export const createWaterQualityLog = async (data) => {
  const res = await apiClient.post("/pool/water-quality", data);
  return res.data;
};

export const recordWaterRetest = async (id, data) => {
  const res = await apiClient.post(`/pool/water-quality/${id}/retest`, data);
  return res.data;
};

// --- CLEANING ---
export const getCleaningSchedules = async (poolId = null) => {
  const res = await apiClient.get("/pool/cleaning-schedules", {
    params: poolId ? { pool_id: poolId } : {}
  });
  return res.data;
};

export const createCleaningSchedule = async (data) => {
  const res = await apiClient.post("/pool/cleaning-schedules", data);
  return res.data;
};

export const completeCleaningTask = async (id, data) => {
  const res = await apiClient.post(`/pool/cleaning-schedules/${id}/complete`, data);
  return res.data;
};

export const getCleaningLogs = async (params = {}) => {
  const res = await apiClient.get("/pool/cleaning-logs", { params });
  return res.data;
};

// --- MAINTENANCE ---
export const getMaintenanceRecords = async (params = {}) => {
  const res = await apiClient.get("/pool/maintenance", { params });
  return res.data;
};

export const createMaintenanceRecord = async (data) => {
  const res = await apiClient.post("/pool/maintenance", data);
  return res.data;
};

export const updateMaintenanceRecord = async (id, data) => {
  const res = await apiClient.put(`/pool/maintenance/${id}`, data);
  return res.data;
};

// --- SAFETY & INCIDENTS ---
export const getSafetyInspections = async (params = {}) => {
  const res = await apiClient.get("/pool/safety-inspections", { params });
  return res.data;
};

export const createSafetyInspection = async (data) => {
  const res = await apiClient.post("/pool/safety-inspections", data);
  return res.data;
};

export const getIncidents = async (params = {}) => {
  const res = await apiClient.get("/pool/incidents", { params });
  return res.data;
};

export const createIncident = async (data) => {
  const res = await apiClient.post("/pool/incidents", data);
  return res.data;
};

export const authorizeReopeningIncident = async (id, data) => {
  const res = await apiClient.post(`/pool/incidents/${id}/authorize-reopening`, data);
  return res.data;
};

// --- CHEMICALS ---
export const getChemicalConsumptions = async (params = {}) => {
  const res = await apiClient.get("/pool/chemicals", { params });
  return res.data;
};

export const recordChemicalConsumption = async (data) => {
  const res = await apiClient.post("/pool/chemicals", data);
  return res.data;
};

// --- LESSONS ---
export const getLessons = async (params = {}) => {
  const res = await apiClient.get("/pool/lessons", { params });
  return res.data;
};

export const createLesson = async (data) => {
  const res = await apiClient.post("/pool/lessons", data);
  return res.data;
};

export const updateLesson = async (id, data) => {
  const res = await apiClient.put(`/pool/lessons/${id}`, data);
  return res.data;
};

export const getLessonEnrollments = async (lessonId) => {
  const res = await apiClient.get(`/pool/lessons/${lessonId}/enrollments`);
  return res.data;
};

export const enrollStudent = async (lessonId, data) => {
  const res = await apiClient.post(`/pool/lessons/${lessonId}/enroll`, data);
  return res.data;
};

export const markLessonAttendance = async (enrollmentId) => {
  const res = await apiClient.post(`/pool/lessons/enrollments/${enrollmentId}/attendance`);
  return res.data;
};

// --- SHIFT HANDOVERS ---
export const getShiftHandovers = async (params = {}) => {
  const res = await apiClient.get("/pool/shift-handovers", { params });
  return res.data;
};

export const createShiftHandover = async (data) => {
  const res = await apiClient.post("/pool/shift-handovers", data);
  return res.data;
};
